import {client} from "../graphql/client";
import {gql} from "@apollo/client";

export const GET_FILE_UPLOAD_URL = gql`
  mutation StorageMutation($input: FileUrlInput!) {
    getFileUploadUrl(input: $input) {
      uploadUrl
      objectKey
      expiresAt
    }
  }
`;

export const GET_PUBLIC_FILE_UPLOAD_URL = gql`
  mutation PublicStorageMutation($input: FileUrlInput!) {
    getPublicFileUploadUrl(input: $input) {
      uploadUrl
      objectKey
      expiresAt
    }
  }
`;

/**
 * 上传文件并获取对象键
 * @param file 要上传的文件
 * @returns 包含对象键的Promise
 */
export const fileUpload = async (
    file: File, tag?: string
): Promise<{ objectKey: string, uploadUrl: string }> => {
    // 获取上传URL
    const { data } = await client.mutate({
        mutation: GET_FILE_UPLOAD_URL,
        variables: {
            input: {
                filename: file.name,
                contentType: file.type,
                usage: tag ? `general/${tag}` : 'general'
            }
        }
    });

    if (!data?.getFileUploadUrl?.uploadUrl || !data?.getFileUploadUrl?.objectKey) {
        throw new Error('Failed to get upload URL');
    }

    const { uploadUrl, objectKey } = data.getFileUploadUrl;

    // 上传文件
    const response = await fetch(uploadUrl, {
        method: 'PUT',
        body: file,
        headers: { 'content-type': 'multipart/form-data' },
    });

    if (!response.ok) {
        throw new Error('Failed to upload file');
    }

    return {
        objectKey,
        uploadUrl
    };
};

/**
 * 上传文件到公开桶并获取对象键
 * @param file 要上传的文件
 * @param tag 标签（可选）
 * @returns 包含对象键的Promise
 */
export const publicFileUpload = async (
    file: File, tag?: string
): Promise<{ objectKey: string, uploadUrl: string }> => {
    const { data } = await client.mutate({
        mutation: GET_PUBLIC_FILE_UPLOAD_URL,
        variables: {
            input: {
                filename: file.name,
                contentType: file.type,
                usage: tag ? `static/${tag}` : 'static'
            }
        }
    });

    if (!data?.getPublicFileUploadUrl?.uploadUrl || !data?.getPublicFileUploadUrl?.objectKey) {
        throw new Error('Failed to get public upload URL');
    }

    const { uploadUrl, objectKey } = data.getPublicFileUploadUrl;

    const response = await fetch(uploadUrl, {
        method: 'PUT',
        body: file,
        headers: { 'content-type': 'multipart/form-data' },
    });

    if (!response.ok) {
        throw new Error('Failed to upload file to public bucket');
    }

    return {
        objectKey,
        uploadUrl
    };
};